import React, { Fragment } from 'react';
import { useTranslate, RichTextField, FunctionField, Show, TextField, DateField } from 'react-admin';
import { AmountField, JsonTextField, AddressField, LinkField } from '../../components/fields';
import { GridShowLayout, Grid } from '../../components/wrapper';
import { makeStyles, Typography } from '@material-ui/core';
import PaymentTransactionLogList from '../paymentTransactionLogs/PaymentTransactionLogList';

const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
	show: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	}
});

const PaymentTransactionShow = props => {
	const classes = useStyles(props);
	const translate = useTranslate();

	return (
		<Fragment>
			<Show className={classes.show} {...props}>
				<GridShowLayout>
					<Grid container>
						<Grid item xs>
							<TextField source="id" />
							<TextField source="externalTransactionId" />
							<DateField source="creationDateTime" showTime />
							<DateField source="externalTransactionDate" showTime />
							<TextField source="gatewayTransactionId" />
							<TextField source="type" />
							<TextField source="status" />
							<DateField source="successDateTime" showTime />
							<TextField source="paymentSettlementStatus" />
						</Grid>
						<Grid item xs>
							<TextField source="errorCode" />
							<TextField source="errorMessage" />
							<TextField source="referencedTransactionId" />
							<TextField source="paymentInstrumentPublicId" />
							<TextField source="businessContractId" />
							<AmountField source="amount" />
						</Grid>
						<Grid item xs>
							<FunctionField
								source="gatewayIdentifier"
								render={record => record && record.gatewayIdentifier ? (
									<span>
										{record.gatewayIdentifier.type}
										<br />
										{record.gatewayIdentifier.id}
									</span>
								) : null}
							/>
							<TextField source="authorizationId" />
							<TextField source="retrievalReferenceNumber" />
							<TextField source="paymentSessionId" />
							<RichTextField source="additionalData" />
							<LinkField source="owner" />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.paymentTransactions.titles.transactionData')}
			</Typography>
			<Show title={' '} className={classes.show} {...props}>
				<GridShowLayout>
					<Grid container>
						<Grid item xs>
							<TextField source="paymentData.firstName" />
							<TextField source="paymentData.lastName" />
							<TextField source="paymentData.email" />
							<TextField source="paymentData.phoneNumber" />
							<AmountField source="paymentData.amount" />
							<TextField source="paymentData.bankStatement" />
							<TextField source="paymentData.mcc" />
						</Grid>
						<Grid item xs>
							{/* ExternalPaymentId has to be changed to LinkField,
							as soon as Purchases are available in the Linkfield component */}
							<TextField source="paymentData.externalPaymentId" />
							<TextField source="paymentData.paymentContext" />
							<TextField source="paymentData.paymentInstrumentStatus" />
							<TextField source="paymentData.riskLevel" />
							<TextField source="paymentData.paRes" />
							<RichTextField source="paymentData.merchantData" />
							<DateField source="paymentData.externalTransactionDate" showTime />
							<TextField source="paymentData.subsidiaryId" />
							<TextField source="paymentData.userIpAddress" />
							<TextField source="paymentData.userLanguage" />
						</Grid>
						<Grid item xs>
							<AddressField source="paymentData.billingAddress" />
							<AddressField source="paymentData.shippingAddress" />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.paymentTransactions.titles.requestResponse')}
			</Typography>
			<Show title={' '} className={classes.show} {...props}>
				<GridShowLayout>
					<Grid container spacing={2}>
						<Grid item xs>
							<JsonTextField source="request" fullWidth />
						</Grid>
						<Grid item xs>
							<JsonTextField source="response" fullWidth />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.paymentTransactionLogs.name')}
			</Typography>
			<PaymentTransactionLogList
				perPage={5}
				{...props}
				title=" "
				basePath={'/paymentTransactionLogs'}
				resource={'paymentTransactionLogs'}
				className={classes.list}
				filter={{
					id: props.id
				}}
			/>
		</Fragment>
	);
};

export default PaymentTransactionShow;
